import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import CronJobList from './CronJobList';
import CronJobShow from './CronJobShow';

export default {
    icon: SettingsApplicationsIcon,
    list: CronJobList,
    show: CronJobShow,
};
